export default "__VITE_ASSET__BWtqdDE7__"